module.exports = __webpack_public_path__ + "images/b45f1266e07b23e287224eef1a567981.png";